import React from "react";
import {
  CrossIcon,
  DeleteIcon,
  MobActiveSelectAllIcon,
  MobSelectAllIcon,
  RestoreIcon,
  StarIcon,
} from "../../Icons";

const FileBulkActionBar = ({
  data = [],
  handleDelete,
  handleFav,
  handleRestore,
  selectedKeys = [],
  setSelectedKeys,
}) => {
  const allSelectableKeys = data.map((row) => row?.id).filter(Boolean);

  const isAllSelected =
    allSelectableKeys.length > 0 &&
    allSelectableKeys.every((key) => selectedKeys.includes(key));

  const enableDelete = !selectedKeys.some((item) => {
    const found = data.find((file) => file?.id === item);
    return found?.upload_type
      ? found.upload_type === "Generated"
      : found?.item_type === "folder";
  });

  const unselectAll = () => {
    setSelectedKeys([]);
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedKeys([]);
    } else {
      setSelectedKeys(allSelectableKeys);
    }
  };

  const handleDeleteClick = () => {
    handleDelete(selectedKeys);
  };
  const handleRestoreClick = () => {
    handleRestore(selectedKeys, setSelectedKeys);
  };

  const handleFavClick = () => {
    const { fileIds, folderIds } = data.reduce(
      (acc, row) => {
        if (!selectedKeys.includes(row?.id)) return acc;
        if (row?.item_type === "file") acc.fileIds.push(row.id);
        else if (row?.item_type === "folder") acc.folderIds.push(row.id);
        return acc;
      },
      { fileIds: [], folderIds: [] },
    );

    const payloads = [];
    if (fileIds.length > 0)
      payloads.push({ item_type: "file", id_array: fileIds });
    if (folderIds.length > 0)
      payloads.push({ item_type: "folder", id_array: folderIds });

    if (payloads.length > 0) handleFav(payloads, setSelectedKeys);
  };

  return (
    <div className="flex items-center justify-between py-[0.5rem]">
      <div className="flex gap-3 items-center">
        <button onClick={unselectAll} className="bg-transparent border-none">
          <CrossIcon />
        </button>
        <div className="text-[#232323] font-medium text-[0.9rem]">
          {selectedKeys?.length} items
        </div>
      </div>
      <div className="flex gap-2 items-center">
        {handleFav && (
          <button
            onClick={handleFavClick}
            className="bg-transparent border-none"
          >
            <StarIcon w="19" h="19" />
          </button>
        )}
        {handleRestore && (
          <button
            onClick={handleRestoreClick}
            className="bg-transparent border-none"
          >
            <RestoreIcon w="19" h="19" />
          </button>
        )}
        {handleDelete && enableDelete && (
          <button
            onClick={handleDeleteClick}
            className="bg-transparent border-none"
          >
            <DeleteIcon w="19" h="19" />
          </button>
        )}
        <button
          onClick={handleSelectAll}
          className="bg-transparent border-none"
        >
          {isAllSelected ? (
            <MobActiveSelectAllIcon w="20" h="20" />
          ) : (
            <MobSelectAllIcon w="20" h="20" />
          )}
        </button>
      </div>
    </div>
  );
};

export default FileBulkActionBar;
